<div class="container-fluid m-0 p-0">
  <div class="blog-header-container">
    <h1 translate>ბლოგი</h1>
  </div>
</div>

<ng-container *ngIf="i18nService.language !== 'EN'">
  <div class="container blog-item custom">
    <h1>
      ლექსუს იზი - ლექსუსის მართვის ახალი გზა
    </h1>
    <h6>ივლისი 2023</h6>
    <br />

    <p>
      ავტომოყვარულებისთვის ცნობილი შეხედულებაა, რომ “მანქანა, რომელსაც მართავ, ბევრს ჰყვება შენზე“. ლექსუსმა ამ იდეის
      სრულყოფა იაპონური სტანდარტით - ლოგოტიპიდან დაიწყო და “გლუვი მოსახვევი“ გამოსახა, რაც მისი ავტომობილების
      აეროდინამიკის პრემიუმ ხარისხს უსვამს ხაზს.
    </p>

    <p>
      წელს თიბისი ლიზინგმა ლექსუსთან ერთად ახალი ფინანსური პროდუქტი - Lexus Easy და Lexus Easy Flex შექმნა, საოპერაციო
      ლიზინგისთვის დამახასიათებელი მოქნილი, მარტივი პირობებით. თუ ახალი ავტომობილის შერჩევასა და სწრაფი დაფინანსების
      მოძიებას ფიქრობ, ეს სტატია შენთვისაა.
    </p>

    <img src="../../../../assets/blog/lexus-easy/img1.jpg" alt="" />

    <p>
      <i class="subhead capital">
        <b>ძირითადი უპირატესობები: </b>
      </i>
    </p>

    <p>
      <i class="subhead capital light-blue">
        <b>სპეციალური ფასი </b>
      </i>
      <br />
      შეარჩიე სასურველი მოდელი ლექსუს საქართველოში და შეიძინე ექსკლუზიურ ფასად
    </p>

    <p>
      <i class="subhead capital light-blue">
        <b>0%-იანი თანამონაწილეობა </b>
      </i>
      <br />
      არ არის საჭირო გქონდეს ე.წ პირველად შესატანი თანხა
    </p>

    <p>
      <i class="subhead capital light-blue">
        <b>დამტკიცების დრო </b>
      </i>
      <br />
      მოითხოვე ლიზინგი, მიიღე დაფინანსება 1 საათში და გაიყვანე ავტომობილი იმავე დღეს
    </p>

    <p>
      <i class="subhead capital light-blue">
        <b>გეგმიური სერვისები </b>
      </i>
      <br />
      სურვილისამებრ ხდება საგარანტიო პერიოდის მანძილზე ჩასატარებელი გეგმიური სერვისების კონტრაქტით გათვალისწინება
    </p>

    <p>
      <i class="subhead capital light-blue">
        <b>TRADE-IN ფუნქცია </b>
      </i>
      <br />
      ჩააბარე ნებისმიერი მოდელი, მის ღირებულებას თანამონაწილეობის თანხად გავითვალისწინებთ და ახალი ლექსუსის გაყვანისას
      გამოგაკლდება.
    </p>

    <p>
      <i class="subhead capital light-blue">
        <b>"LEXUS CASCO"</b>
      </i>
      <br />
      ლექსუსის სპეციალური სადაზღვევო პროდუქტი, რომელიც თქვენს საჭიროებებზეა მორგებული: ინდივიდუალურად გამოთვლილი პრემია,
      უფლებამოსილი მძღოლების შეუზღუდავი რაოდენობა, ავტო-ასისტანსის 24-საათიან უფასო მომსახურებას და სხვა.
    </p>

    <img src="../../../../assets/blog/lexus-easy/img2.jpg" alt="" />

    <p>
      <i class="subhead capital">
        <b>გაეცანი Lexus Easy და Easy Flex-ის პირობებს: </b>
      </i>
    </p>

    <table class="flat-table">
      <thead>
        <tr>
          <th class="naming">ძირითადი უპირატესობები:</th>
          <th>LEXUS EASY</th>
          <th>LEXUS EASY FLEX</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="naming">სპეციალური ფასი ლექსუსის ავტომობილებზე</td>
          <td><b>✓</b></td>
          <td><b>✓</b></td>
        </tr>
        <tr>
          <td class="naming">წინასწარი შენატანი - 0%-დან</td>
          <td><b>✓</b></td>
          <td><b>–</b></td>
        </tr>
        <tr>
          <td class="naming">დაბალი ყოველთვიური გადასახადი</td>
          <td><b>✓</b></td>
          <td><b>✓</b></td>
        </tr>
        <tr>
          <td class="naming">დაბალი საპროცენტო განაკვეთი</td>
          <td><b>✓</b></td>
          <td><b>✓</b></td>
        </tr>
        <tr>
          <td class="naming">გარანტირებული ნარჩენი ღირებულება</td>
          <td><b>✓</b></td>
          <td><b>–</b></td>
        </tr>

        <tr>
          <td class="naming">საგარანტიო პირობებით დაცული ავტომობილი</td>
          <td><b>✓</b></td>
          <td><b>✓</b></td>
        </tr>
        <tr>
          <td class="naming">დამტკიცების დრო</td>
          <td>- 1 საათი</td>
          <td>- 1 საათი</td>
        </tr>
        <tr>
          <td class="naming">კონტრაქტის ხანგრძლივობა</td>
          <td>12-60 თვე</td>
          <td>12-72 თვე</td>
        </tr>
        <tr>
          <td class="naming">კონტრაქტში გათვალისწინებული გეგმიური სერვისები</td>
          <td>არჩევითი</td>
          <td>არჩევითი</td>
        </tr>
        <tr>
          <td class="naming">დამატებითი ფასდაკლება სერვისებზე</td>
          <td><b>✓</b></td>
          <td><b>✓</b></td>
        </tr>
        <tr>
          <td class="naming">ლექსუსის სადაზღვევო პროდუქტი - "Lexus Casco"</td>
          <td><b>✓</b></td>
          <td><b>✓</b></td>
        </tr>
        <tr>
          <td class="naming">
            დაიტოვოს ავტომობილი - იხდით მხოლოდ, ავტომობილის წინასწარ განსაზღვრულ, ნარჩენ ღირებულებას
          </td>
          <td><b>✓</b></td>
          <td><b>–</b></td>
        </tr>
        <tr>
          <td class="naming">დააბრუნოს ავტომობილი - ამისთვის საჭიროა უბრალოდ ავტომობილის დატოვება სერვის ცენტრში</td>
          <td><b>✓</b></td>
          <td><b>–</b></td>
        </tr>
        <tr>
          <td class="naming">განაახლოს ავტომობილი - ჩააბაროს ძველი და გაიყვანოს განახლებული მოდელი</td>
          <td>✓</td>
          <td><b>–</b></td>
        </tr>
      </tbody>
    </table>

    <img src="../../../../assets/blog/lexus-easy/img3.jpg" alt="" />
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-blue">
      <div class="container">
        <p class="bold-text">
          <span class="capitalized-text"
            >რაც მთავარია, პროდუქტი განსაკუთრებულ მოქნილობას განიჭებს. კონტრაქტის ვადის გასვლის შემდეგ შეგიძლია:</span
          >
          <br /><br />

          1. შეინარჩუნო ავტომობილი და განაგრძო მისი მართვა, რისთვისაც მხოლოდ წინასწარ განსაზღვრულ ნარჩენ ღირებულებას
          გადაიხდი. <br /><br />

          2. დააბრუნო ავტომობილი სერვის ცენტრში. <br /><br />

          3. განაახლო ავტომობილი, რისთვისაც ძველის დატოვება მოგიწევს სერვის-ცენტრში.
        </p>
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p>
      <i class="subhead capital">
        <b style="font-size:26px">ისარგებლე Lexus Easy-ით ან Easy Flex-ით და მართე ლექსუსი - მარტივად. </b>
      </i>
    </p>
  </div>
</ng-container>

<ng-container *ngIf="i18nService.language === 'EN'">
  <div class="container blog-item custom">
    <h1>
      Lexus Easy - The New Way to Drive a Lexus
    </h1>
    <h6>July 2023</h6>
    <br />

    <p>
      It is a well-known belief among car enthusiasts that "the car you drive says a lot about you." Lexus has perfected
      this idea with Japanese standards, starting from the logo, which features a "smooth curve" that highlights the
      premium aerodynamics of its vehicles.
    </p>

    <p>
      This year, TBC Leasing, together with Lexus, has created a new financial product - Lexus Easy and Lexus Easy Flex,
      offering flexible and simple terms typical of operational leasing. If you're considering selecting a new vehicle
      and finding quick financing, this article is for you.
    </p>

    <img src="../../../../assets/blog/lexus-easy/img1.jpg" alt="" />

    <p>
      <i class="subhead capital">
        <b>Main Advantages:</b>
      </i>
    </p>

    <p>
      <i class="subhead capital light-blue">
        <b>Special Price</b>
      </i>
      <br />
      Choose your desired Lexus model in Georgia and purchase it at an exclusive price.
    </p>

    <p>
      <i class="subhead capital light-blue">
        <b>0% Contribution</b>
      </i>
      <br />
      No need for an upfront payment (initial contribution).
    </p>

    <p>
      <i class="subhead capital light-blue">
        <b>Approval Time</b>
      </i>
      <br />
      Request leasing, receive financing in 1 hour, and drive away with your car the same day.
    </p>

    <p>
      <i class="subhead capital light-blue">
        <b>Scheduled Services</b>
      </i>
      <br />
      You can opt for a contract for scheduled services during the warranty period.
    </p>

    <p>
      <i class="subhead capital light-blue">
        <b>TRADE-IN Function</b>
      </i>
      <br />
      Trade in any model, and its value will be considered as part of the contribution, reducing the cost of the new
      Lexus.
    </p>

    <p>
      <i class="subhead capital light-blue">
        <b>"LEXUS CASCO"</b>
      </i>
      <br />
      A special insurance product for Lexus, tailored to your needs: individually calculated premium, unlimited number
      of authorized drivers, 24-hour free roadside assistance, and more.
    </p>

    <img src="../../../../assets/blog/lexus-easy/img2.jpg" alt="" />

    <table class="flat-table">
      <thead>
        <tr>
          <th class="naming">ძირითადი უპირატესობები:</th>
          <th>LEXUS EASY</th>
          <th>LEXUS EASY FLEX</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="naming">Special Price for Lexus Vehicles</td>
          <td><b>✓</b></td>
          <td><b>✓</b></td>
        </tr>
        <tr>
          <td class="naming">Prepayment - From 0%</td>
          <td><b>✓</b></td>
          <td><b>–</b></td>
        </tr>
        <tr>
          <td class="naming">Low Monthly Payment</td>
          <td><b>✓</b></td>
          <td><b>✓</b></td>
        </tr>
        <tr>
          <td class="naming">Low Interest Rate</td>
          <td><b>✓</b></td>
          <td><b>✓</b></td>
        </tr>
        <tr>
          <td class="naming">Guaranteed Residual Value</td>
          <td><b>✓</b></td>
          <td><b>–</b></td>
        </tr>

        <tr>
          <td class="naming">Car Protected by Warranty</td>
          <td><b>✓</b></td>
          <td><b>✓</b></td>
        </tr>
        <tr>
          <td class="naming">Approval Time</td>
          <td>- 1 hour</td>
          <td>- 1 hour</td>
        </tr>
        <tr>
          <td class="naming">Contract Duration</td>
          <td>12-60 months</td>
          <td>12-72 months</td>
        </tr>
        <tr>
          <td class="naming">Scheduled Services Included in the Contract</td>
          <td>Optional</td>
          <td>Optional</td>
        </tr>
        <tr>
          <td class="naming">Additional Discount on Services</td>
          <td><b>✓</b></td>
          <td><b>✓</b></td>
        </tr>
        <tr>
          <td class="naming">Lexus Insurance Product - "Lexus Casco"</td>
          <td><b>✓</b></td>
          <td><b>✓</b></td>
        </tr>
        <tr>
          <td class="naming">Keep the Car - Pay Only the Pre-Determined Residual Value</td>
          <td><b>✓</b></td>
          <td><b>–</b></td>
        </tr>
        <tr>
          <td class="naming">Return the Car - Just Leave the Car at the Service Center</td>
          <td><b>✓</b></td>
          <td><b>–</b></td>
        </tr>
        <tr>
          <td class="naming">Renew the Car - Trade in Your Old Car for a New Model</td>
          <td>✓</td>
          <td><b>–</b></td>
        </tr>
      </tbody>
    </table>

    <img src="../../../../assets/blog/lexus-easy/img3.jpg" alt="" />
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-blue">
      <div class="container">
        <p class="bold-text">
          <span class="capitalized-text"
            >The most important thing is that the product provides exceptional flexibility. After the contract term
            ends, you can:
          </span>
          <br /><br />

          1. Keep the car and continue driving it by paying only the pre-determined residual value. <br /><br />

          2. Return the car to the service center. <br /><br />

          3. Renew the car, for which you will need to leave the old one at the service center.
        </p>
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p>
      <i class="subhead capital">
        <b style="font-size:26px">Enjoy Lexus Easy or Easy Flex and drive a Lexus – effortlessly.</b>
      </i>
    </p>
  </div>
</ng-container>
